import { defineNuxtPlugin } from '#app'
import localforage from 'localforage'

export default defineNuxtPlugin(() => {
  if (process.client) {
    try {
      const videoStore = localforage.createInstance({
        name: 'VideoPositionStore',
        driver: [
          localforage.INDEXEDDB,
          localforage.WEBSQL,
          localforage.LOCALSTORAGE
        ]
      })

      // 把超过30天的断点记录移除，节省indexedDB空间
      const clear = async () => {
        try {
          // 检查存储是否可用
          const driver = videoStore.driver()
          if (!driver) {
            console.warn('VideoPositionStore: No storage driver available')
            return
          }

          const keys = await videoStore.keys()
          const now = Date.now()
          for (const key of keys) {
            const data = await videoStore.getItem<{
              position: number
              time: number
            }>(key)
            if (!data) continue
            if (now - data.time > 30 * 24 * 60 * 60 * 1000) {
              await videoStore.removeItem(key)
            }
          }
        } catch (error) {
          console.warn('VideoPositionStore: Failed to clear old records', error)
        }
      }

      videoStore.ready().then(() => {
        clear()
      })
    } catch (error) {
      console.warn('VideoPositionStore: Failed to initialize', error)
    }
  }
})
